export default __webpack_public_path__ + "static/media/solarpaneldiagram.3ca21247.png";